export default {"src":"/_next/static/media/link-circle.c9134f82.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};